import { useToastContext } from '@/app/providers'

export function useToast() {
  return useToastContext()
}
